import styled from "styled-components";

const HeatMapConstraint = styled.div`
  flex-grow: 1;
  position: relative;
`;

export default HeatMapConstraint;
